import * as i0 from '@angular/core';
import { Injectable, Component, ChangeDetectionStrategy, Optional, ViewChild, Inject, InjectionToken, NgModule } from '@angular/core';
import { Observable, Subject, isObservable, map } from 'rxjs';
import { take, filter } from 'rxjs/operators';
import * as i1 from '@capturum/api';
import { ApiService } from '@capturum/api';
import { HttpParams, HttpUrlEncodingCodec } from '@angular/common/http';
import * as i2 from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import * as i3 from '@ngx-translate/core';
import * as i2$2 from '@capturum/ui/api';
import { DynamicDialogcontentDirective, CapturumDialogService, SessionStorageService, LocalStorageService, CapturumSharedModule, CapturumPropertyValuePipe } from '@capturum/ui/api';
import * as i1$1 from 'primeng/dynamicdialog';
import { DynamicDialogComponent, DynamicDialogModule } from 'primeng/dynamicdialog';
import * as i2$1 from '@angular/common';
import { DOCUMENT, CommonModule, DatePipe } from '@angular/common';
import * as i3$1 from '@capturum/ui/sidebar';
import { CapturumSidebarModule } from '@capturum/ui/sidebar';
import * as i1$2 from '@angular/router';
import { CapturumInputModule } from '@capturum/ui/input';
import { SidebarModule } from 'primeng/sidebar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { AbstractControl } from '@angular/forms';
function DynamicSidebarComponent_ng_container_2_ng_template_1_Template(rf, ctx) {}
function DynamicSidebarComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicSidebarComponent_ng_container_2_ng_template_1_Template, 0, 0, "ng-template", 3);
    i0.ɵɵelementContainerEnd();
  }
}
let CapturumBuildersContextService = /*#__PURE__*/(() => {
  class CapturumBuildersContextService {
    constructor() {
      this.context = {};
    }
    setContext(key, context) {
      this.context[key] = context;
    }
    getContextByKey(key) {
      return this.context[key];
    }
    clearContextByKey(key) {
      this.context[key] = null;
    }
    getHttpParamsContext(key) {
      const context = this.context[key];
      if (context) {
        let httpParams = new HttpParams({
          encoder: new MyCustomHttpUrlEncodingCodec()
        });
        for (const objectKey in context) {
          if (context.hasOwnProperty(objectKey)) {
            httpParams = httpParams.append(`_context[${objectKey}]`, context[objectKey]);
          }
        }
        return httpParams;
      }
      return null;
    }
    static {
      this.ɵfac = function CapturumBuildersContextService_Factory(t) {
        return new (t || CapturumBuildersContextService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CapturumBuildersContextService,
        factory: CapturumBuildersContextService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CapturumBuildersContextService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class MyCustomHttpUrlEncodingCodec extends HttpUrlEncodingCodec {
  encodeKey(k) {
    return super.encodeKey(k).replace(new RegExp('%5B', 'g'), '[').replace(new RegExp('%5D', 'g'), ']');
  }
}
let BuilderApiService = /*#__PURE__*/(() => {
  class BuilderApiService extends ApiService {
    constructor(apiHttpService, contextService) {
      super(apiHttpService);
      this.apiHttpService = apiHttpService;
      this.contextService = contextService;
    }
    post(key, endpoint, data) {
      const params = this.contextService.getHttpParamsContext(key);
      return this.apiHttp.post(endpoint, this.recursiveParse(data), {
        params
      });
    }
    patch(key, endpoint, data) {
      const params = this.contextService.getHttpParamsContext(key);
      return this.apiHttp.patch(endpoint, this.recursiveParse(data), {
        params
      });
    }
    get(key, endpoint) {
      const params = this.contextService.getHttpParamsContext(key);
      return this.apiHttp.get(endpoint, {
        params
      });
    }
    static {
      this.ɵfac = function BuilderApiService_Factory(t) {
        return new (t || BuilderApiService)(i0.ɵɵinject(i1.ApiHttpService), i0.ɵɵinject(CapturumBuildersContextService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BuilderApiService,
        factory: BuilderApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return BuilderApiService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ConfirmationBackendAction = /*#__PURE__*/(() => {
  class ConfirmationBackendAction {
    constructor(apiHttp, confirmationService, translateService) {
      this.apiHttp = apiHttp;
      this.confirmationService = confirmationService;
      this.translateService = translateService;
    }
    execute(options, item) {
      if (options.endpoint) {
        return new Observable(observer => {
          this.confirmationService.confirm({
            header: options.confirmation_title ?? this.translateService.instant('builders.confirmation.title'),
            message: options.confirmation_text ?? '',
            accept: () => {
              this.apiHttp.post(options.configurationKey, options.endpoint, Array.isArray(item) ? item : [item]).pipe(take(1)).subscribe(response => {
                observer.next({
                  response
                });
                observer.complete();
              });
            },
            reject: () => {
              observer.next(null);
              observer.complete();
            }
          });
        });
      } else {
        throw new Error(`Endpoint not provided for action "${options.action.key}". Please provide an endpoint in the configuration of the action`);
      }
    }
    static {
      this.ɵfac = function ConfirmationBackendAction_Factory(t) {
        return new (t || ConfirmationBackendAction)(i0.ɵɵinject(BuilderApiService), i0.ɵɵinject(i2.ConfirmationService), i0.ɵɵinject(i3.TranslateService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ConfirmationBackendAction,
        factory: ConfirmationBackendAction.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ConfirmationBackendAction;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DynamicSidebarComponent = /*#__PURE__*/(() => {
  class DynamicSidebarComponent {
    constructor(componentFactoryResolver, cd, renderer, config, dialogRef) {
      this.componentFactoryResolver = componentFactoryResolver;
      this.cd = cd;
      this.renderer = renderer;
      this.config = config;
      this.dialogRef = dialogRef;
    }
    ngAfterViewInit() {
      if (this.childComponentType) {
        this.loadChildComponent(this.childComponentType);
        this.cd.detectChanges();
        if (this.config) {
          this.title = this.config.header;
        }
        // Make sure the animation is triggered for opening the sidebar
        setTimeout(() => {
          this.visible = true;
          this.cd.detectChanges();
        }, 100);
      }
    }
    loadChildComponent(componentType) {
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(componentType);
      const viewContainerRef = this.insertionPoint.viewContainerRef;
      viewContainerRef.clear();
      this.componentRef = viewContainerRef.createComponent(componentFactory);
    }
    static {
      this.ɵfac = function DynamicSidebarComponent_Factory(t) {
        return new (t || DynamicSidebarComponent)(i0.ɵɵdirectiveInject(i0.ComponentFactoryResolver), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i1$1.DynamicDialogConfig), i0.ɵɵdirectiveInject(i1$1.DynamicDialogRef, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DynamicSidebarComponent,
        selectors: [["cpb-dynamic-sidebar"]],
        viewQuery: function DynamicSidebarComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(DynamicDialogcontentDirective, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.insertionPoint = _t.first);
          }
        },
        decls: 3,
        vars: 3,
        consts: [["styleClass", "right-sidebar", "position", "right", 3, "visible", "title"], [1, "right-sidebar__content"], [4, "ngIf"], ["capDynamicDialogContent", ""]],
        template: function DynamicSidebarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "cap-sidebar", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, DynamicSidebarComponent_ng_container_2_Template, 2, 0, "ng-container", 2);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("visible", ctx.visible)("title", ctx.title);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.childComponentType);
          }
        },
        dependencies: [i2$1.NgIf, i3$1.CapturumSidebarComponent, i2$2.DynamicDialogcontentDirective],
        changeDetection: 0
      });
    }
  }
  return DynamicSidebarComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OpenContainerAction = /*#__PURE__*/(() => {
  class OpenContainerAction {
    constructor(dialogService, builderCoreConfig) {
      this.dialogService = dialogService;
      this.builderCoreConfig = builderCoreConfig;
    }
    execute(options, item) {
      const componentKey = `${options.configurationKey}_${options.action.key}`;
      const component = (this.builderCoreConfig?.components && this.builderCoreConfig.components[componentKey]) ?? options.action.options.component;
      if (component) {
        this.dialogService.open(component, {
          header: options.title,
          data: {
            item,
            ...options
          },
          width: options.width || '70%',
          styleClass: componentKey
        }, options.containerType || DynamicDialogComponent);
      } else {
        throw Error(`Component with key "${componentKey}" not found. Make sure to provide the component in the forRoot config of the CapturumBuilderCoreModule`);
      }
    }
    static {
      this.ɵfac = function OpenContainerAction_Factory(t) {
        return new (t || OpenContainerAction)(i0.ɵɵinject(CapturumDialogService), i0.ɵɵinject(BuilderCoreConfigService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: OpenContainerAction,
        factory: OpenContainerAction.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return OpenContainerAction;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OpenSidebarAction = /*#__PURE__*/(() => {
  class OpenSidebarAction {
    constructor(openContainerAction) {
      this.openContainerAction = openContainerAction;
    }
    execute(options, item) {
      this.openContainerAction.execute({
        ...options,
        containerType: DynamicSidebarComponent
      }, item);
    }
    static {
      this.ɵfac = function OpenSidebarAction_Factory(t) {
        return new (t || OpenSidebarAction)(i0.ɵɵinject(OpenContainerAction));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: OpenSidebarAction,
        factory: OpenSidebarAction.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return OpenSidebarAction;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NavigateAction = /*#__PURE__*/(() => {
  class NavigateAction {
    constructor(router, interpolationPipe, document) {
      this.router = router;
      this.interpolationPipe = interpolationPipe;
      this.document = document;
    }
    execute(options, item, context = {}) {
      if (options?.route) {
        this.route = this.interpolationPipe.transform(options.route, {
          ...context,
          ...item
        });
        if (this.route.endsWith('/')) {
          this.route = this.route.slice(0, -1); // remove last character
        }

        if (options?.control_click && options?.action?.ctrlKey) {
          this.openNewWindow();
        } else {
          this.router.navigateByUrl(this.route);
        }
      }
    }
    openNewWindow() {
      const origin = this.document.location.origin;
      const tabUrl = `${origin}${this.route}`;
      window.open(tabUrl, '_blank');
    }
    static {
      this.ɵfac = function NavigateAction_Factory(t) {
        return new (t || NavigateAction)(i0.ɵɵinject(i1$2.Router), i0.ɵɵinject(i2$2.InterpolationPipe), i0.ɵɵinject(DOCUMENT));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: NavigateAction,
        factory: NavigateAction.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return NavigateAction;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const CAPTURUM_BUILDERS_BASE_URL = new InjectionToken('Capturum builder base URL');
let ConfigurationNavigateAction = /*#__PURE__*/(() => {
  class ConfigurationNavigateAction {
    constructor(router, baseUrl, interpolationPipe) {
      this.router = router;
      this.baseUrl = baseUrl;
      this.interpolationPipe = interpolationPipe;
    }
    execute(options, item) {
      const url = this.interpolationPipe.transform(options.route, item);
      this.router.navigate([`${this.baseUrl}${url}`]);
    }
    static {
      this.ɵfac = function ConfigurationNavigateAction_Factory(t) {
        return new (t || ConfigurationNavigateAction)(i0.ɵɵinject(i1$2.Router), i0.ɵɵinject(CAPTURUM_BUILDERS_BASE_URL), i0.ɵɵinject(i2$2.InterpolationPipe));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ConfigurationNavigateAction,
        factory: ConfigurationNavigateAction.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ConfigurationNavigateAction;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OpenDialogAction = /*#__PURE__*/(() => {
  class OpenDialogAction {
    constructor(openContainerAction) {
      this.openContainerAction = openContainerAction;
    }
    execute(options, item) {
      this.openContainerAction.execute({
        ...options,
        containerType: DynamicDialogComponent
      }, item);
    }
    static {
      this.ɵfac = function OpenDialogAction_Factory(t) {
        return new (t || OpenDialogAction)(i0.ɵɵinject(OpenContainerAction));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: OpenDialogAction,
        factory: OpenDialogAction.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return OpenDialogAction;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BackendAction = /*#__PURE__*/(() => {
  class BackendAction {
    constructor(apiHttp, builderApiHttpService) {
      this.apiHttp = apiHttp;
      this.builderApiHttpService = builderApiHttpService;
    }
    execute(options, item) {
      if (options.endpoint) {
        return this.builderApiHttpService.post(options.contextKey || options.configurationKey, options.endpoint, Array.isArray(item) ? item : [item]).pipe(take(1));
      } else {
        throw new Error(`Endpoint not provided for action "${options.action.key}". Please provide an endpoint in the configuration of the action`);
      }
    }
    static {
      this.ɵfac = function BackendAction_Factory(t) {
        return new (t || BackendAction)(i0.ɵɵinject(i1.ApiHttpService), i0.ɵɵinject(BuilderApiService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BackendAction,
        factory: BackendAction.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return BackendAction;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const defaultCapturumBuilderActions = {
  navigate: NavigateAction,
  configurationNavigate: ConfigurationNavigateAction,
  open_sidebar: OpenSidebarAction,
  open_popup: OpenDialogAction,
  backend: BackendAction,
  backend_confirmation: ConfirmationBackendAction
};
const CAPTURUM_BUILDERS_CONFIG_STORAGE_PROVIDERS = new InjectionToken('Capturum builder config storage providers');
const BUILDERS_CORE_CONFIG = new InjectionToken('BUILDERS_CORE_CONFIG');
let BuilderCoreConfigService = /*#__PURE__*/(() => {
  class BuilderCoreConfigService {
    constructor(storageProviders, injector) {
      this.storageProviders = storageProviders;
      this.injector = injector;
      this._actions = {
        ...defaultCapturumBuilderActions
      };
      this._components = {};
    }
    get actions() {
      return this._actions;
    }
    get components() {
      return this._components;
    }
    getStorageClassByKey(key) {
      switch (key) {
        case 'session':
          return this.injector.get(SessionStorageService);
        case 'local':
          return this.injector.get(LocalStorageService);
        default:
          return this.injector.get(this.storageProviders?.[key] || SessionStorageService);
      }
    }
    addConfig(config) {
      if (config.components) {
        Object.keys(config.components).forEach(componentKey => {
          if (!this._components[componentKey]) {
            this._components[componentKey] = config.components[componentKey];
          }
        });
      }
      if (config.actions) {
        this._actions = {
          ...this.actions,
          ...config.actions
        };
      }
    }
    static {
      this.ɵfac = function BuilderCoreConfigService_Factory(t) {
        return new (t || BuilderCoreConfigService)(i0.ɵɵinject(CAPTURUM_BUILDERS_CONFIG_STORAGE_PROVIDERS, 8), i0.ɵɵinject(i0.Injector));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BuilderCoreConfigService,
        factory: BuilderCoreConfigService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return BuilderCoreConfigService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumBuilderActionService = /*#__PURE__*/(() => {
  class CapturumBuilderActionService {
    constructor(injector, builderCoreConfig, contextService, translateService, toastService) {
      this.injector = injector;
      this.builderCoreConfig = builderCoreConfig;
      this.contextService = contextService;
      this.translateService = translateService;
      this.toastService = toastService;
      this.actionExecutionMessages = new Subject();
    }
    executeAction(action, response, configurationKey, contextKey) {
      const context = this.contextService.getContextByKey(contextKey || configurationKey);
      if (action) {
        if (this.builderCoreConfig.actions[action.type]) {
          const instance = this.injector.get(this.builderCoreConfig.actions[action.type]);
          if (instance) {
            const actionResponse = instance.execute({
              ...action.options,
              configurationKey,
              contextKey,
              action
            }, response, context);
            if (isObservable(actionResponse)) {
              actionResponse.pipe(take(1)).subscribe(actionResult => {
                this.broadcastActionExecuted(action, response, actionResult);
              });
            } else {
              this.broadcastActionExecuted(action, response, actionResponse);
            }
          }
        } else {
          throw Error(`Action "${action.type}" not found. Make sure to provide the action in the forRoot config of the CapturumBuilderCoreModule`);
        }
      }
    }
    /**
     * Broad cast action executed
     *
     * @description This function will broadcast an executeds action. It will send the action, item and response if available
     * @param action - The action which was executed
     * @param item - The item on which the action was executed
     * @param response - The response of the action
     */
    broadcastActionExecuted(action, item, response) {
      this.actionExecutionMessages.next({
        action,
        item,
        response
      });
      if (response) {
        this.actionSuccessNotification(action);
      }
    }
    /**
     * Retrieve action executions
     *
     * @description Every time an action gets executed a message will be broadcasted with the action, the item and the response of the action (if available)
     * Use this function to subscribe to these actions
     *
     * @return Observable<ActionExecutionMessage>
     */
    getActionExecutions() {
      return this.actionExecutionMessages.asObservable();
    }
    /**
     * Retrieve action executions by key
     *
     * @description Every time an action gets executed a message will be broadcasted with the action, the item and the response of the action (if available)
     * Use this function to subscribe to a specific action by providing the action key
     *
     * @param actionKey - The key of the action
     *
     * @return Observable<ActionExecutionMessage>
     */
    getActionExecutionByActionKey(actionKey) {
      return this.actionExecutionMessages.asObservable().pipe(filter(actionMessage => actionMessage.action.key === actionKey));
    }
    /**
     * Retrieve action executions
     *
     * @description Every time an action gets successfully executed an we have message will show as success notification with that message
     *
     */
    actionSuccessNotification(action) {
      const message = action?.options?.message || action?.message;
      if (message) {
        const title = this.translateService.instant('toast.success.title');
        this.toastService.success(title, message);
      }
    }
    static {
      this.ɵfac = function CapturumBuilderActionService_Factory(t) {
        return new (t || CapturumBuilderActionService)(i0.ɵɵinject(i0.Injector), i0.ɵɵinject(BuilderCoreConfigService), i0.ɵɵinject(CapturumBuildersContextService), i0.ɵɵinject(i3.TranslateService), i0.ɵɵinject(i2$2.ToastService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CapturumBuilderActionService,
        factory: CapturumBuilderActionService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CapturumBuilderActionService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function responseData(source) {
  return new Observable(subscriber => {
    source.subscribe({
      next(value) {
        if (value) {
          subscriber.next(value.data);
        }
        subscriber.complete();
      },
      error(error) {
        subscriber.error(error);
      }
    });
  });
}
function apiListResultToMapItem(result, valueProperty = 'value', labelProperty = 'label') {
  return result.data.map(item => {
    return {
      label: item[labelProperty],
      value: item[valueProperty]
    };
  });
}
function toMapItems(source, valueProperty = 'key', labelProperty = 'label') {
  return new Observable(subscriber => {
    source.subscribe({
      next(value) {
        if (value !== undefined && value !== null) {
          subscriber.next(apiListResultToMapItem(value, valueProperty, labelProperty));
        }
      },
      error(error) {
        subscriber.error(error);
      },
      complete() {
        subscriber.complete();
      }
    });
  });
}
let ConfigApiService = /*#__PURE__*/(() => {
  class ConfigApiService extends ApiService {
    constructor(apiHttp) {
      super(apiHttp);
      this.endpoint = '/builder/ui/config';
    }
    setConfig(configId) {
      return this.apiHttp.get(`${this.endpoint}/${configId}/set`);
    }
    getConfigByKey(type, key) {
      return this.apiHttp.get(`${this.endpoint}/by-key/${type}_${key}`).pipe(responseData, map(data => data[0]));
    }
    static {
      this.ɵfac = function ConfigApiService_Factory(t) {
        return new (t || ConfigApiService)(i0.ɵɵinject(i1.ApiHttpService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ConfigApiService,
        factory: ConfigApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ConfigApiService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const CAPTURUM_BUILDERS_CONFIG_LIST_URL = new InjectionToken('Capturum builder config list URL');
let CapturumBuilderCoreModule = /*#__PURE__*/(() => {
  class CapturumBuilderCoreModule {
    constructor(configService, configs = []) {
      if (!configs) {
        return;
      }
      configs.forEach(config => configService.addConfig(config));
    }
    static forRoot(config) {
      return {
        ngModule: CapturumBuilderCoreModule,
        providers: [{
          provide: BUILDERS_CORE_CONFIG,
          useValue: config,
          multi: true
        }, BuilderCoreConfigService, {
          provide: CAPTURUM_BUILDERS_BASE_URL,
          useValue: config.baseUrl || '/admin/builder'
        }, {
          provide: CAPTURUM_BUILDERS_CONFIG_LIST_URL,
          useValue: config.configListUrl || '/config'
        }, {
          provide: CAPTURUM_BUILDERS_CONFIG_STORAGE_PROVIDERS,
          useValue: config.storageProviders || {}
        }]
      };
    }
    static forChild(config) {
      return {
        ngModule: CapturumBuilderCoreModule,
        providers: [{
          provide: BUILDERS_CORE_CONFIG,
          useValue: config,
          multi: true
        }]
      };
    }
    static {
      this.ɵfac = function CapturumBuilderCoreModule_Factory(t) {
        return new (t || CapturumBuilderCoreModule)(i0.ɵɵinject(BuilderCoreConfigService), i0.ɵɵinject(BUILDERS_CORE_CONFIG, 8));
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CapturumBuilderCoreModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [CapturumDialogService, CapturumPropertyValuePipe, ConfirmationService],
        imports: [CommonModule, SidebarModule, CapturumSidebarModule, CapturumInputModule, CapturumSharedModule, DynamicDialogModule, ConfirmDialogModule]
      });
    }
  }
  return CapturumBuilderCoreModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var InputType = /*#__PURE__*/function (InputType) {
  InputType["checkbox"] = "checkbox";
  InputType["checkboxValue"] = "checkboxvalue";
  InputType["checkboxList"] = "checkboxlist";
  InputType["text"] = "text";
  InputType["textarea"] = "textarea";
  InputType["custom"] = "custom";
  InputType["label"] = "label";
  InputType["email"] = "email";
  InputType["dropdown"] = "dropdown";
  InputType["image"] = "image";
  InputType["number"] = "number";
  InputType["date"] = "date";
  InputType["group"] = "group";
  InputType["radio"] = "radio";
  InputType["file"] = "file";
  InputType["multiSelect"] = "multiselect";
  InputType["toggle"] = "toggle";
  InputType["repeat"] = "repeat";
  InputType["autocomplete"] = "autocomplete";
  InputType["translated"] = "translated";
  InputType["numberFormat"] = "numberFormat";
  InputType["entityText"] = "entitytext";
  InputType["editor"] = "editor";
  InputType["hidden"] = "hidden";
  InputType["url"] = "url";
  InputType["range"] = "range";
  InputType["password"] = "password";
  InputType["icon"] = "icon";
  return InputType;
}(InputType || {});
var DependencyOperator = /*#__PURE__*/function (DependencyOperator) {
  DependencyOperator["and"] = "and";
  DependencyOperator["or"] = "or";
  return DependencyOperator;
}(DependencyOperator || {});
var LabelPosition = /*#__PURE__*/function (LabelPosition) {
  LabelPosition["Above"] = "above";
  LabelPosition["Before"] = "before";
  LabelPosition["Floating"] = "floating";
  return LabelPosition;
}(LabelPosition || {});
var CapturumBuilderType = /*#__PURE__*/function (CapturumBuilderType) {
  CapturumBuilderType["page"] = "page";
  CapturumBuilderType["form"] = "form";
  CapturumBuilderType["list"] = "list";
  return CapturumBuilderType;
}(CapturumBuilderType || {});
var PageBuilderWidgetType = /*#__PURE__*/function (PageBuilderWidgetType) {
  PageBuilderWidgetType["row"] = "row";
  PageBuilderWidgetType["list"] = "list";
  PageBuilderWidgetType["form"] = "form";
  PageBuilderWidgetType["text"] = "text";
  PageBuilderWidgetType["button"] = "button";
  return PageBuilderWidgetType;
}(PageBuilderWidgetType || {});
// @dynamic
class DateHelper {
  static toGeneralFormat(date) {
    return new DatePipe('en').transform(date, 'yyyy-MM-ddTHH:mm:ssZZZ');
  }
  static getRange([start, end]) {
    return [this.getStartOfDay(start), this.getEndOfDay(end ?? start)];
  }
  static getStartOfDay(startDate) {
    const start = new Date(startDate);
    start.setHours(0, 0, 0, 0);
    return this.toGeneralFormat(start);
  }
  static getEndOfDay(endDate) {
    const end = new Date(endDate);
    end.setHours(23, 59, 59, 999);
    return this.toGeneralFormat(end);
  }
  static timezoneManipulation(date) {
    const timeOffsetInMS = date.getTimezoneOffset() * 60000;
    date.setTime(date.getTime() - timeOffsetInMS);
    return date;
  }
  static fromStringToDate(date) {
    if (date && Array.isArray(date)) {
      return date.map(item => {
        if (item) {
          return new Date(item);
        }
        return item;
      });
    } else if (typeof date === 'string') {
      return new Date(date);
    }
    return null;
  }
}
function clone(value) {
  if (!isObject(value) || isObservable(value) || /* instanceof SafeHtmlImpl */value.changingThisBreaksApplicationSecurity || ['RegExp', 'FileList', 'File', 'Blob'].indexOf(value.constructor.name) !== -1) {
    return value;
  }
  // https://github.com/moment/moment/blob/master/moment.js#L252
  if (value._isAMomentObject && isFunction(value.clone)) {
    return value.clone();
  }
  if (value instanceof AbstractControl) {
    return null;
  }
  if (value instanceof Date) {
    return new Date(value.getTime());
  }
  if (Array.isArray(value)) {
    return value.slice(0).map(v => clone(v));
  }
  // best way to clone a js object maybe
  // https://stackoverflow.com/questions/41474986/how-to-clone-a-javascript-es6-class-instance
  const proto = Object.getPrototypeOf(value);
  let c = Object.create(proto);
  c = Object.setPrototypeOf(c, proto);
  // need to make a deep copy so we dont use Object.assign
  // also Object.assign wont copy property descriptor exactly
  return Object.keys(value).reduce((newVal, prop) => {
    const propDesc = Object.getOwnPropertyDescriptor(value, prop);
    if (propDesc.get) {
      Object.defineProperty(newVal, prop, propDesc);
    } else {
      newVal[prop] = clone(value[prop]);
    }
    return newVal;
  }, c);
}
function isObject(x) {
  return x != null && typeof x === 'object';
}
function isFunction(value) {
  return typeof value === 'function';
}
function controlsEqual(controlName, equalToName, errorKey = controlName) {
  return form => {
    const control = form.get(controlName);
    if (!control) {
      return null;
    }
    if (control.value !== form.get(equalToName).value) {
      control.setErrors({
        [errorKey]: true
      });
      return {
        [errorKey]: true
      };
    } else {
      control.setErrors(null);
      return null;
    }
  };
}

// Services

/**
 * Generated bundle index. Do not edit.
 */

export { BUILDERS_CORE_CONFIG, BackendAction, BuilderApiService, BuilderCoreConfigService, CAPTURUM_BUILDERS_BASE_URL, CAPTURUM_BUILDERS_CONFIG_LIST_URL, CapturumBuilderActionService, CapturumBuilderCoreModule, CapturumBuilderType, CapturumBuildersContextService, ConfigApiService, ConfigurationNavigateAction, ConfirmationBackendAction, DateHelper, DependencyOperator, InputType, LabelPosition, MyCustomHttpUrlEncodingCodec, NavigateAction, OpenContainerAction, OpenDialogAction, PageBuilderWidgetType, apiListResultToMapItem, clone, controlsEqual, defaultCapturumBuilderActions, isFunction, isObject, responseData, toMapItems };
